import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'
import moduleCalendar from './calendar/moduleCalendar.js'
import moduleChat from './chat/moduleChat.js'
import moduleConfig from './config/moduleConfig.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleEmail from './email/moduleEmail.js'
import moduleTodo from './todo/moduleTodo.js'


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    calendar: moduleCalendar,
    chat: moduleChat,
    config: moduleConfig,
    eCommerce: moduleECommerce,
    email: moduleEmail,
    todo: moduleTodo,
  },

  strict: process.env.NODE_ENV !== 'production'

})
